import { render } from "./PlayIcon.vue?vue&type=template&id=5e670531"
import script from "./PlayIcon.vue?vue&type=script&lang=js"
export * from "./PlayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__